import { StyleSheet } from 'react-native';
import theme from '@/constants/colors';
import { Typography } from '@/constants/typography';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.backgroundPrimary,
    paddingHorizontal: 0,
    paddingBottom: 0,
  },
  scrollView: {
    flex: 1,
  },
  content: {
    padding: 24,
  },
  bigHeader: {
    paddingTop: 24,
    paddingBottom: 12,
  },
  bottomTitle: {
    ...Typography.h1(theme.accentPrimary),
    fontSize: 28,
    marginBottom: 8,
  },
  bottomSubtitle: {
    ...Typography.body(theme.textMuted),
    marginBottom: 16,
  },
  sectionLabel: {
    ...Typography.label(theme.accentPrimary),
    fontSize: 16,
    marginBottom: 12,
  },
  // Environment chips
  chip: {
    paddingHorizontal: 20,
    paddingVertical: 12,
    borderRadius: 24,
    backgroundColor: '#282E10',
    borderWidth: 1.5,
    borderColor: '#3d4520',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  chipSelected: {
    backgroundColor: 'rgba(255, 254, 119, 0.15)',
    borderColor: theme.accentPrimary,
  },
  chipText: {
    ...Typography.label(theme.accentPrimary),
    paddingHorizontal: 4,
  },
  chipTextSelected: {
    ...Typography.label(theme.accentPrimary),
    fontWeight: '700' as any,
    paddingHorizontal: 4,
  },
  // Level chips (Low / Some / Lots)
  chipRow: {
    flexDirection: 'row',
    gap: 8,
  },
  levelChip: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    paddingHorizontal: 10,
    paddingVertical: 12,
    borderRadius: 14,
    backgroundColor: '#282E10',
    borderWidth: 1.5,
    borderColor: '#3d4520',
  },
  levelChipSelected: {
    backgroundColor: 'rgba(255, 254, 119, 0.15)',
    borderColor: theme.accentPrimary,
  },
  levelChipText: {
    ...Typography.label(theme.accentPrimary),
    fontSize: 13,
  },
  levelChipTextSelected: {
    ...Typography.label(theme.accentPrimary),
    fontWeight: '700' as any,
  },
  // Traffic 1-5 buttons
  trafficRow: {
    flexDirection: 'row',
    gap: 8,
  },
  trafficButton: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 10,
    borderRadius: 12,
    backgroundColor: '#282E10',
    borderWidth: 1.5,
    borderColor: '#3d4520',
  },
  trafficButtonSelected: {
    backgroundColor: 'rgba(255, 254, 119, 0.15)',
    borderColor: theme.accentPrimary,
  },
  trafficButtonNumber: {
    color: theme.accentPrimary,
    fontSize: 18,
    fontWeight: '700' as any,
    lineHeight: 22,
  },
  trafficButtonNumberSelected: {
    color: theme.accentPrimary,
  },
  trafficButtonLabel: {
    color: theme.textMuted,
    fontSize: 10,
    fontWeight: '500' as any,
    marginTop: 2,
  },
  trafficButtonLabelSelected: {
    color: theme.accentPrimary,
  },

  // Footer
  footer: {
    flexDirection: 'row',
    gap: 12,
    paddingHorizontal: 24,
    paddingTop: 20,
    borderTopWidth: 1,
    borderTopColor: theme.borderSubtle,
    backgroundColor: theme.backgroundPrimary,
  },
  backButton: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    backgroundColor: 'transparent',
    borderRadius: 12,
    padding: 18,
    borderWidth: 1.5,
    borderColor: theme.accentPrimary,
  },
  backButtonText: {
    ...Typography.label(theme.accentPrimary),
    paddingHorizontal: 4,
  },
  nextButtonLarge: {
    flex: 1,
    backgroundColor: theme.accentPrimary,
    borderRadius: 12,
    padding: 18,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 56,
  },
  nextButtonText: {
    ...Typography.button('#1a1f0a'),
    paddingHorizontal: 4,
  },
});

export default styles;